export default "__VITE_ASSET__9FDb89Of__"